<a href="/" [attr.aria-label]="'BROCOM — wyposażenie przemysłowe' | translate" class="logo-link">
  <img
    src="images/logo-dark.png"
    [alt]="'BROCOM Industry' | translate"
    [ngClass]="size === 'desktop' ? 'w-36 h-auto max-w-full' : 'h-7 w-auto max-w-full'"
  />
</a>
